<template>
  <div
    ref="wrap"
    class="fixed bottom-0 left-full top-0 z-30 w-full max-w-[400px] transition"
    :class="{ '-translate-x-full': modelValue }"
  >
    <div class="h-full bg-white">
      <div class="flex h-full flex-col">
        <div class="z-40 mb-2 py-4">
          <div class="container">
            <div class="flex items-center justify-between">
              <div class="title text-xl uppercase text-slate">
                {{ title }}
              </div>
              <button aria-label="close" @click="close">
                <UiIcon icon="close" class="h-6 w-6"></UiIcon>
              </button>
            </div>
          </div>
        </div>
        <div class="flex-grow overflow-y-auto py-4">
          <div class="container">
            <slot></slot>
          </div>
        </div>
        <div class="z-40 bg-white p-4">
          <slot name="footer" v-bind="{ close }"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { useBodyScrollLock } from '~/composables';

interface Props {
  modelValue?: boolean;
  title?: string;
}
interface Emits {
  (e: 'update:modelValue', data: boolean): void;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  title: 'Filter title',
});

useBodyScrollLock(() => props.modelValue);

const emit = defineEmits<Emits>();
const wrap = ref();

const close = () => {
  emit('update:modelValue', false);
};

onClickOutside(wrap, () => {
  close();
});
</script>
